import React from 'react'
import { type IntegrationServiceId } from '../../../common/integrations'
import { IntegrationIcon } from '../../../components/IntegrationIcon'
import { UserActionButton } from './UserActionButton'

interface IntegrationUserActionButtonProps {
  serviceId: IntegrationServiceId
  label: string
  onClick: () => void
}

export const IntegrationUserActionButton: React.FC<IntegrationUserActionButtonProps> = ({ serviceId, label, onClick }) => {
  return (
    <UserActionButton
      icon={<IntegrationIcon serviceId={serviceId} fill='var(--zocks-gray-900)' width='1rem' height='1rem' />}
      label={label}
      onClick={onClick}
    />
  )
}
